import { Checkbox, Chip, FormControlLabel, Theme, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React, { ChangeEvent, FC } from "react";
import { AgencyCode } from "../../../../../reducers/states/agency";
import { customTheme } from "../../../../..";

const useStyles = makeStyles((theme: Theme) => ({
  filter: {
    paddingRight: 0,
    marginRight: 0,
    marginLeft: 0,
  },
  notAvailable: {
    color: theme.palette.error.main,
  },
}));

interface AgencyFilterProps {
  props: {
    agency: string;
    agencyFilters: string[];
    isFeedDown: boolean;
    tooltip?: string;
    handleAgencySelect: (event: ChangeEvent<HTMLInputElement>) => void;
  };
}

const AgencyFilter: FC<AgencyFilterProps> = ({ props }) => {
  const classes = useStyles();

  const getChipColor = (agency: string) => {
    switch (agency) {
      case AgencyCode.KCM: {
        return customTheme.agency.KCM;
      }
      case AgencyCode.SFD: {
        return customTheme.agency.SFD;
      }
      case AgencyCode.SPD: {
        return customTheme.agency.SPD;
      }
    }

    if (agency.startsWith(AgencyCode.WSP)) {
      return customTheme.agency.WSP;
    }
  };

  return (
    <FormControlLabel
      className={classes.filter}
      control={
        <Tooltip title={props.tooltip ?? undefined}>
          <Checkbox
            name={props.agency}
            checked={props.agencyFilters.includes(props.agency)}
            onChange={props.handleAgencySelect}
            checkedIcon={
              <Chip
                style={{ backgroundColor: getChipColor(props.agency), color: "white" }}
                variant="filled"
                label={props.agency}
              />
            }
            icon={<Chip variant="outlined" label={props.agency} />}
            sx={{ padding: "5px" }}
          />
        </Tooltip>
      }
      label={
        props.isFeedDown ? (
          <Tooltip
            title={
              props.agency +
              "'s data feed is currently down or experiencing problems. The system will check for updates in 30 seconds"
            }
          >
            <HighlightOffIcon className={classes.notAvailable} />
          </Tooltip>
        ) : (
          undefined
        )
      }
    />
  );
};

export default AgencyFilter;
